/* eslint-disable react-refresh/only-export-components */
import { GenericType } from "@/types";
import React, { createContext } from "react";

type ClassificationProviderProp = {
  children: React.ReactNode;
  state: GenericType;
  setState: GenericType;
};

export const ClassificationContext = createContext<GenericType>(null);

export const ClassificationProvider = ({
  children,
  state,
  setState,
}: ClassificationProviderProp) => {
  return (
    <ClassificationContext.Provider value={[state, setState]}>
      {children}
    </ClassificationContext.Provider>
  );
};
